import React, {Component} from 'react';
import {Navigate} from 'react-router-dom';
import redirectURL from "../redirectURL";
import './styles.css';
import Cookies from 'js-cookie';
import Canvas from "react-numeric-captcha";
import "./captch.css";

export default class Login extends Component {
	constructor(props)
	{
		super(props);
		this.state={
			isNav:0,
			email:"",
			password:"",
			loginMessage:"",
			clickReset:false,
			isCaptchaValid:false,
			captchaMsg:''
		}
		this.changeHandler = this.changeHandler.bind(this);
	}
	componentDidMount(){
		// redirectURL.post("/login/welcome")
		// .then((response) => {
		// 	console.log("response ", response.data)
		// })
	}

	onClickGoToDashboard(){
		redirectURL.post("/login/welcome")
		.then((response) => {
			localStorage.setItem("token","1xEdr125dg6577dfgjseXbnddgxuy2kg")
		
			this.setState({
				isNav:1
			});
		})
		
	}
	changeHandler(event){
		var name = event.target.name;
		var value = event.target.value;
		this.setState({
			[name]:value
		})
	}
	formSubmit(event){
		event.preventDefault();
		if(this.state.email !=undefined && this.state.email !="" && this.state.password !=undefined && this.state.password !="")
		{
			var params = {
				e:this.state.email,
				d:this.state.password
			}
			redirectURL.post("/verify",params)
			.then((response) => {
				if(response.data.status == "success")
				{
				// if (!this.state.isCaptchaValid){
				// 	this.setState({captchaMsg:'Invalid Captcha',
				// 					loginMessage:''})
				// 	}else{
					localStorage.setItem("email",response.data.user[0].email);
					localStorage.setItem("firstname",response.data.user[0].firstname);
					localStorage.setItem("lastname",response.data.user[0].lastname);
					localStorage.setItem("username",response.data.user[0].username);
					Cookies.set('username',response.data.user[0].username,{ expires: 7 })
					Cookies.set('token',response.data.user[0].username,{ expires: 7 })
			
					localStorage.setItem("token",response.data.token);
					localStorage.setItem("user_type",response.data.user[0].user_type);
					localStorage.setItem("userid",response.data.user[0]._id);
					localStorage.setItem("role",response.data.user[0].role);
					localStorage.setItem("user_code",response.data.user[0].user_code);
					this.setState({
						isNav : 1
					})

                    // var url = window.location.host;
                    // var environment = ''
                    // if (url === '216.48.191.229:3011') {
                    //     environment='DEV'
                    // }else if (url==='164.52.218.255:3009'){
                    //     environment='QA'
                    // }else if(url==='nestle.enmovil.net'){
                    //     environment='UAT'
                    // }else if(url==='nestle.optirun.in'){
                    //     environment='PROD'
                    // }else{
                    //     environment="Local"
                    // }
					// params.environment=environment
					// params.msg='Logged Into'
					// if(response.data.user[0].client =='nestle'){
					// 	redirectURL.post("/master/triggerEmail",params)
					// 	.then((response)=>{
					// 		})
					// }
				// }	
				}
				else
				{
					this.setState({
						loginMessage : response.data.message,
						captchaMsg:''
					})
				}
			})
		}
		else
		{
			this.setState({
				loginMessage : "Enter Email and Password",
				captchaMsg:''
			})
		}
		
	}
	clickOnForgotPasswd=()=>{
		this.setState({clickReset:true})
		return <Navigate  to={"/reset"} push={true} />
	}
	
	handleCaptchaChange = (isValid) => {
		this.setState({isCaptchaValid:isValid})
	  };

    render(){

		if(this.state.isNav === 1)
		{
			if(localStorage.getItem("user_type") === "SERVICE"){
				return <Navigate  to={"/home"} push={true} />
			}else{
				return <Navigate  to={"/"} push={true} />
			}
		}

		if(localStorage.getItem("token") != null){
			if (Cookies.get('token')!== undefined && Cookies.get('token')!=='' && Cookies.get('token')!== null  ){
				return <Navigate  to={"/"} push={true} />
		}}
		
		if(this.state.clickReset){
			return <Navigate  to={"/reset"} push={true} />
		}

        return (
			<div className='container-fluid container-bg'>
				<div className='row'>
					<div className='col-sm-12'>	
						<div className='form-body col-6'>
							{/* <div> */}
							<form className="loginForm" onSubmit={this.formSubmit.bind(this)} style={{alignItems:'center',display:'flex',flexDirection:'column'}}>
								<h4>Login</h4>
								{(this.state.loginMessage)?
								<div className="alert alert-danger">{this.state.loginMessage}</div>
								:""}
								<div className="form-group" style={{marginTop: "2em",width:'90%'}}>
									<input type="email" className="form-control form-control-user" id="exampleInputEmail" name="email" onChange={this.changeHandler} aria-describedby="emailHelp" placeholder="Enter Email Address..." autocomplete="off" />
								</div>
								<div className="form-group  txt-center d-flex justify-content-center" style={{width:'90%'}}>
									<input type="password" className="form-control form-control-password" id="exampleInputPassword" name="password" onChange={this.changeHandler} placeholder="Password" autocomplete="off" />
								</div>{(this.state.captchaMsg)?
								<div className="alert alert-danger">{this.state.captchaMsg}</div>
								:""}
								<div className="form-group  txt-center" style={{width:'55%'}}>
									<button type="submit" className="btn btn-user">
										Login
									</button>
								</div>
							</form>
							</div>
							{/* <button onClick={this.clickOnForgotPasswd} className="btn btn-user">
										Forgotten password?
						</button>
						</div> */}
						
					</div>
				</div>
			</div>
        )
    }
}